module.exports = __webpack_public_path__ + "img/sweets.e99d43eb.svg";